<template>
  <router-link :to="chatPath" class="cb-btn" :aria-label="`Chat (${unreadCount} unread)`" @click="clearBadge">
    <font-awesome-icon icon="comment-dots" />
    <transition name="cb-pop">
      <span v-if="unreadCount > 0" class="cb-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    </transition>
  </router-link>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ChatBell',
  data() {
    return {
      unreadCount: 0,
      pollTimer: null,
    };
  },
  computed: {
    chatPath() {
      const code = this.$route?.params?.companyCode || localStorage.getItem('companyCode') || '';
      return code ? `/${code}/hr/chat` : '/hr/chat';
    },
  },
  mounted() {
    this.fetchCount();
    this.pollTimer = setInterval(this.fetchCount, 30000);
  },
  beforeUnmount() {
    clearInterval(this.pollTimer);
  },
  methods: {
    async fetchCount() {
      try {
        const { data } = await axios.get('/hr/chat/unread-count');
        this.unreadCount = data.data?.count ?? 0;
      } catch {
        // silent — don't surface network errors in the badge
      }
    },
    clearBadge() {
      this.unreadCount = 0;
    },
  },
};
</script>

<style scoped>
.cb-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: #4a5e78;
  font-size: 18px;
  padding: 6px 8px;
  border-radius: 8px;
  text-decoration: none;
  transition: background .15s, color .15s;
}
.cb-btn:hover { background: #f0f4f8; color: #004AAD; }
.cb-btn.router-link-active { color: #004AAD; }

.cb-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 17px;
  height: 17px;
  border-radius: 99px;
  background: #dc2626;
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  border: 2px solid #fff;
}

/* pop-in animation for badge */
.cb-pop-enter-active { transition: transform .2s cubic-bezier(.34,1.56,.64,1), opacity .15s; }
.cb-pop-leave-active { transition: transform .12s, opacity .12s; }
.cb-pop-enter-from   { transform: scale(0); opacity: 0; }
.cb-pop-leave-to     { transform: scale(0); opacity: 0; }
</style>
